import { makeFacialRecognitionsRepository } from 'shared/infra/repositories';

import { FetchFacialRecognitionUseCase } from './implementations/FetchFacialRecognitionUseCase';

let instance: FetchFacialRecognitionUseCase | null = null;

export default function makeFetchFacialRecognitionUseCase() {
  if (!instance) {
    const repository = makeFacialRecognitionsRepository();
    instance = new FetchFacialRecognitionUseCase(repository);
  }

  return instance;
}
